import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { renderStandardPictureElement } from "../../utils";

export default {
    title: "Components/Teaser Icon",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-teaser-icon",
    args: {
        shadow: "false",
    },
    argTypes: {
        shadow: {
            control: "boolean",
        },
    },
};

const DefaultSlots = () => html`
    <div
        slot="title"
        class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase"
        data-same-height="title"
    >
        <strong>Medienpool</strong>
    </div>
    <div slot="link">
        <a href="#" class="ux-text-link ux-text-link--green">
            Mehr erfahren<ux-icon name="arrow-small-right"
        /></a>
    </div>
`;

const Template = ({
    iconName,
    iconSize,
    shadow,
    variant,
}) => html` <ux-iws-teaser-icon
    icon-name="${iconName}"
    icon-size="${iconSize}"
    shadow="${shadow}"
    variant="${variant}"
>
    ${DefaultSlots()}
</ux-iws-teaser-icon>`;

export const Default = Template.bind({});
Default.args = {
    iconName: "calendar",
    variant: "default",
};
Default.argTypes = {
    iconName: {
        options: ["calendar", "camera", "bag", "avatar-wrench"],
        control: { type: "radio" },
    },
};

const TemplateServiceIcon = ({
    iconName,
    iconSize,
    shadow,
    variant,
}) => html` <ux-iws-teaser-icon
    icon-name="${iconName}"
    icon-size="${iconSize}"
    shadow="${shadow}"
    variant="${variant}"
>
    ${DefaultSlots()}
</ux-iws-teaser-icon>`;

export const ServiceIcon = TemplateServiceIcon.bind({});
ServiceIcon.args = {
    iconName: "calendar",
    variant: "service-icon",
    shadow: true,
};
ServiceIcon.argTypes = {
    iconName: {
        options: ["calendar", "camera", "bag", "avatar-wrench"],
        control: { type: "radio" },
    },
};

const TemplateImage = ({
    iconName,
    iconSize,
    shadow,
    variant,
}) => html` <ux-iws-teaser-icon
    icon-name="${iconName}"
    icon-size="${iconSize}"
    shadow="${shadow}"
    variant="${variant}"
>
    <div slot="image">
        ${renderStandardPictureElement({ width: 1700, height: 800 })}
    </div>
    ${DefaultSlots()}
</ux-iws-teaser-icon>`;

export const Image = TemplateImage.bind({});
Image.args = {
    variant: "image",
    shadow: true,
};

const TemplatePlain = ({
    iconName,
    iconSize,
    shadow,
    variant,
}) => html` <ux-iws-teaser-icon
    icon-name="${iconName}"
    icon-size="${iconSize}"
    shadow="${shadow}"
    variant="${variant}"
>
    ${DefaultSlots()}
</ux-iws-teaser-icon>`;

export const Plain = TemplatePlain.bind({});
Plain.args = {
    iconName: "calendar",
    variant: "plain",
    shadow: true,
};
Plain.argTypes = {
    iconName: {
        options: ["calendar", "camera", "bag", "avatar-wrench"],
        control: { type: "radio" },
    },
};

const TemplateDisabled = ({
    iconName,
    iconSize,
    shadow,
    variant,
}) => html` <ux-iws-teaser-icon
    icon-name="${iconName}"
    icon-size="${iconSize}"
    shadow="${shadow}"
    variant="${variant}"
    class="is-disabled"
>
    ${DefaultSlots()}
</ux-iws-teaser-icon>`;

export const Disabled = TemplateDisabled.bind({});
Disabled.args = {
    iconName: "calendar",
};
